import CacheCleaner from "./CacheCleaner";
import HorseResidenceCleaner from "./HorseResidenceCleaner";

export default class LieuCleaner extends CacheCleaner {

	async onMutation(lieu_ids) {
		await HorseResidenceCleaner.inst().onLieuMutation(lieu_ids)
	}
}
